// src/layouts/MainLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/layout.css";

const MainLayout = () => {
  return (
    <div className="app-shell">
      <Navbar />

      <main className="app-main" role="main">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};

export default MainLayout;
